<template>
  <div class="fulfillment-detail-card">
    <p class="fulfillment-detail-card_title">
      {{ title }}
    </p>
    <div class="flex items-start gap-[10px]">
      <span>:</span>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.fulfillment-detail-card {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 10px;

  p {
    margin: 0;
  }
}

.fulfillment-detail-card_title {
  width: 100%;
  max-width: 200px;
}

@media (max-width: 608px) {
  .fulfillment-detail-card {
    flex-direction: column;
  }
}
</style>
